import { tickerItems } from '@/mocks/home';

export default function Ticker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-b border-background-200 bg-background-100">
      <div className="flex items-stretch">
        <div className="flex items-center gap-2 bg-primary-500 px-3 md:px-6 py-2 text-background-50 shrink-0">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill text-xs" />
          </span>
          <span className="text-xs font-label tracking-[0.25em] whitespace-nowrap">今日快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="asc-marquee flex w-max items-center gap-8 py-2 pl-4 pr-8">
            {loop.map((text, i) => (
              <span
                key={i}
                className="flex items-center gap-2 text-xs md:text-sm font-label text-foreground-700 whitespace-nowrap"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}